import Swiper from 'swiper';

export default class Slider {
	constructor() {
        this.swiperCarousel = document.querySelector('[data-is="swiper"]');

        this.init();
    }
    
    init() {
        this.swiper = new Swiper(this.swiperCarousel, {
            slidesPerView: 'auto',
            centeredSlides: false,
            initialSlide: 1,
            loop: true,
            threshold: 10,
            breakpoints: {
                576: {
                    centeredSlides: true,
                }
            }
        });
    }
}
